import { NgModule } from '@angular/core';
import { PrimengModule } from './primeng.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TablaComponent } from './components/tabla/tabla.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogUserComponent } from './components/dialog-user/dialog-user.component';
import { ImagePreloadDirective } from 'src/app/core';
import { TablaGenericaComponent } from './components/tabla-generica/tabla-generica.component';


@NgModule({
  declarations: [
    TablaComponent,
    DialogComponent,
    DialogUserComponent,
    ImagePreloadDirective,
    TablaGenericaComponent
  ],
  imports: [
    PrimengModule,
    FormsModule,
    CommonModule
  ],
  exports: [
    PrimengModule,
    FormsModule,
    TablaComponent,
    DialogComponent,
    DialogUserComponent,
    ImagePreloadDirective,
    TablaGenericaComponent
  ]
})
export class SharedModule { }
